import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Message, Panel, Row } from 'rsuite'
import { Controller, useForm } from 'react-hook-form'
//import { useParams } from 'react-router-dom'
import CheckboxRowForm from '../../components/forms/checkboxRowForm/CheckboxRowForm'
import EditButton from '../../components/buttons/editButton/EditButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { getRequiredData } from '../../utils/ValidatorUtils'
import { saveComplianceObjectives } from '../../redux/actions/proposalGoal'
import { doneLoading, startLoading } from '../../utils/loading'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import { saveConfirmActualResult } from '../../redux/actions/closeOfProject'
import WarningMessage from '../../components/message/WarningMessage/WarningMessage'

export default function ComplianceObjectives(props) {
  const {
    showCommandButton,
    schema,
    checked,
    isConfirmActualResult = false,
    isEdit,
    onChangeIsEdit,
    numberOfInstallment,
    onSuccess = () => {},
  } = props
  const dispatch = useDispatch()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(schema)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const userId = sessionStorage.getItem('proposal_id')

  const handleUpdateGoalTenYear = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      let response

      const data = {
        optionSelected: request.optionSelected,
      }

      response = await saveComplianceObjectives(projectId, data)

      if (response) {
        setFormSchema(response.model)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }

      onChangeIsEdit(false)
    } catch (e) {
      setIsError(true)
    }

    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)
    let optionSelected = formSchema.options.map((item) => {
      if (data[item.name]) {
        return item.value
      }
      return null
    })

    optionSelected = optionSelected.filter((item) => item !== null)

    const requiredData = getRequiredData(formSchema.validators)
    if (requiredData && optionSelected.length === 0 && !data.inputOtherCheckbox) {
      setError('checkbox', {
        type: 'manual',
        message: requiredData.errorMessage,
      })
      return
    }

    let inputOtherValue = ''
    if (data.inputOtherCheckbox) {
      inputOtherValue = data.inputOther
    }

    if (optionSelected) {
      formSchema.optionSelected = optionSelected
    } else {
      formSchema.optionSelected = []
    }

    handleUpdateGoalTenYear(formSchema)
  }

  const onSubmitConfActualResult = (data) => {
    console.log('onSubmitConfActualResult => ', data)

    let optionSelected = formSchema.options.map((item) => {
      if (data[item.name]) {
        return item.value
      }
      return null
    })

    optionSelected = optionSelected.filter((item) => item !== null)

    const requiredData = getRequiredData(formSchema.validators)
    if (requiredData && optionSelected.length === 0 && !data.inputOtherCheckbox) {
      setError('checkbox', {
        type: 'manual',
        message: requiredData.errorMessage,
      })
      return
    }

    let request = {
      optionSelected: optionSelected,
      inputOther: data.inputOther,
      confType: 'ComplianceObjective',
      targetLists: null,
      numberOfInstallment: numberOfInstallment,
      inputCriteria: null,
      year: null,
      version: null,
    }

    handleSaveConfirmActualResult(request)
  }

  const handleSaveConfirmActualResult = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const response = await saveConfirmActualResult(projectId, request)
      console.log('response : ', response)
      if (response.success) {
        onSuccess(true)

        // const saveResp = await getCloseOfProjectCoworkerForm(projectId)
        //
        // let _formSchema = cloneDeep(formSchema)
        //
        // _formSchema.optionSelected = saveResp?.forms?.confirmActualResul?.goal?.goalTenYear?.optionSelected || null
        //
        // setCheckedConf(saveResp?.forms?.confirmActualResulChecked?.goalTenYearChecked || null)
        // setFormSchema(_formSchema)

        // await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
        onSuccess(false)
      }
    } catch (e) {
      setIsError(true)
      onSuccess(false)
    }

    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded={!isConfirmActualResult}
        header={formSchema.header || formSchema.title}
        bordered
        collapsible
        defaultExpanded
      >
        <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

        {isEdit && showCommandButton ? (
          <CheckboxRowForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        ) : (
          <div>
            {formSchema.optionSelected.length === 0 ? (
              <span>- ไม่ได้ระบุ -</span>
            ) : (
              <ul>
                {formSchema.optionSelected.map((item) => {
                  const _selected = formSchema.options.filter((i) => i.value === item)
                  const _label = _selected.length ? _selected[0].label : ''
                  return (
                    <li key={item} style={{ marginBottom: 8 }}>
                      {_label}
                    </li>
                  )
                })}
                {formSchema.inputOther?.enable && formSchema.inputOther?.isSelected && (
                  <li>{formSchema.inputOther.value}</li>
                )}
              </ul>
            )}
          </div>
        )}

        {showCommandButton && (
          <>
            <hr />
            {isEdit ? (
              <>
                {isError && (
                  <Row style={{ marginBottom: 10 }}>
                    <Message
                      showIcon
                      type="error"
                      description={
                        'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                      }
                    />
                  </Row>
                )}

                {isConfirmActualResult ? (
                  <>
                    {checked && (
                      <Message
                        showIcon
                        type={checked.checkedType ? 'success' : 'error'}
                        description={
                          <div dangerouslySetInnerHTML={{ __html: checked.detail || '' }} />
                        }
                        style={{ marginBottom: 10 }}
                      />
                    )}

                    <SaveButton
                      icon="views-authorize"
                      onClick={handleSubmit(onSubmitConfActualResult)}
                      // disabled={!!checked?.checkedType || isLoading}
                      disabled={isLoading}
                      children={'ยืนยันการดำเนินการจริง'}
                    />
                  </>
                ) : (
                  <>
                    <SaveButton onClick={handleSubmit(onSubmit)} />
                    <CancelButton onClick={() => onChangeIsEdit(false)} />
                  </>
                )}
              </>
            ) : (
              <>
                <EditButton onClick={() => onChangeIsEdit(true)}>
                  แก้ไขความสอดคล้องกับวัตถุประสงค์
                </EditButton>
              </>
            )}
          </>
        )}
      </Panel>
    </>
  )
}
